import { gql } from './apollo';

export const CREATE_ACCOUNT_PROPERTY = gql`
    mutation (
        $property__c: MultiTypeInput!
        $account__c: MultiTypeInput!
        $sfid: MultiTypeInput!
        $createddate: MultiTypeInput
    ) {
        createRow(
            table: "accountproperty__c"
            values: [
                { property: "property__c", value: $property__c }
                { property: "account__c", value: $account__c }
                { property: "sfid", value: $sfid }
                { property: "isdeleted", value: false }
                { property: "createddate", value: $createddate }
            ]
        )
    }
`;
